import Vue from "vue";
import Router from "vue-router";

import HomePanel from "@/views/HomePanel";

import Home from "@/views/Home";
import Service from "@/views/Service";
import About from "@/views/About";
import Contact from "@/views/Contact";

import scommunity from "@/components/Service/scommunity";
import shealth from "@/components/Service/shealth";
import smec from "@/components/Service/smec";
import sservice from "@/components/Service/sservice";

import aprofile from "@/components/About/aprofile";
import aqualification from "@/components/About/aqualification";

import league_cooperation from "@/components/Contact/league_cooperation";
import recruitment from "@/components/Contact/recruitment";

import "../assets/css/reset.css";
import "@/assets/css/style.css";

Vue.use(Router);
export default new Router({
    // base: "wesite",
    // mode: "history",
    routes: [
        {
            path: "/",
            component: HomePanel,
            children: [
                { path: "/", redirect: "/home", component: Home },
                { path: "/home", component: Home },
                {
                    path: "/service",
                    component: Service,
                    children: [
                        { path: "/service/", redirect: "/service/sservice", component: sservice },
                        { path: "/service/sservice", component: sservice },
                        { path: "/service/smec", component: smec },
                        { path: "/service/shealth", component: shealth },
                        { path: "/service/scommunity", component: scommunity },
                    ],
                },
                {
                    path: "/about",
                    component: About,
                    children: [
                        { path: "/about/", redirect: "/about/aprofile", component: aprofile },
                        { path: "/about/aprofile", component: aqualification },
                        { path: "/about/aqualification", component: aprofile },
                    ],
                },
                {
                    path: "/contact",
                    component: Contact,
                    children: [
                        { path: "/contact/", redirect: "/contact/league_cooperation", component: league_cooperation },
                        { path: "/contact/league_cooperation", component: league_cooperation },
                        { path: "/contact/recruitment", component: recruitment },
                    ],
                },
            ],
        }
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js